import React from 'react';
import intl from 'src/locale';
import styles from './ProgressPercent.module.css';

interface ProgressPercentProps {
  currentQuestionIndex: number;
  questionCount: number;
}

export const ProgressPercent = ({ currentQuestionIndex, questionCount }: ProgressPercentProps) => {
  const totalWithFinal = questionCount + 1;
  const current = currentQuestionIndex + 1;
  const percent = Math.ceil((current / totalWithFinal) * 100);

  return (
    <span className={styles.progress}>
      <span>{intl.formatMessage({ id: 'ProgressBar.Percent' })}</span>
      <span className={styles.percent}>{`${percent}%`}</span>
    </span>
  );
};
